import gql from 'graphql-tag';

/**
 * Voucher cho mục "Ưu đãi đặc biệt" trên homepage.
 * Query không có argument: BE tự suy khách hàng từ token (guest -> voucher cho tất cả khách hàng).
 * Đặt tên khác `getVouchers` vì `utils/query/getVouchers.ts` đã bị dùng cho
 * `availableVouchersForStore` (export là `getAvailableVouchers`).
 */
export default gql`
  query getVouchers {
    getVouchers {
      data {
        id
        code
        nameVn
        nameEn
        descriptionVn
        descriptionEn
        discountType
        discountMinPrice
        discountPercent
        discountMaxValue
        startDate
        endDate
        isDisabled
        categoryIds
        brandIds
        productSkus
      }
    }
  }
`;
